import type { FunctionComponent } from "react";

import { BaseInput } from "./base-input";
import type { BaseInputProps } from "./types";

type InputProps = BaseInputProps;

export const Input: FunctionComponent<InputProps> = (props) => {
	return <BaseInput {...props} ref={props.ref} />;
};

Input.displayName = "Input";
